// This file contains the privacy policy for the iHtrack app, a mobile inventory management application.
// It outlines the information collected, how it's used, and user rights regarding their data.

const HTrackPrivacyPolicy = () => {
  // This component renders the privacy policy for the iHtrack app.
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="text-sm text-gray-500 mb-8">
        Effective Date: 04/26/2026
        <br />
        Last Updated: 04/27/2026
      </p>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">
          1. Information We Collect
        </h2>
        <p>
          iHtrack respects your privacy. We do not collect or store any personal
          data on external servers. All your inventory data, including images,
          names, and quantities, are stored{" "}
          <strong>locally on your device</strong>.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">
          2. How We Use Your Information
        </h2>
        <p>
          Since your data remains on your device, we only use it to:
          <ul className="list-disc list-inside mt-2">
            <li>Display your inventory items</li>
            <li>Allow you to edit, add, or remove inventory</li>
            <li>Personalize your user experience</li>
          </ul>
          We do <strong>not</strong> share, sell, or transfer your information
          to any third parties.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">
          3. Photos and Media Access
        </h2>
        <p>
          iHtrack may request access to your photo library when you add or update
          item images or a location image. This access is used{" "}
          <strong>only</strong> for the photos you explicitly select.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">4. Your Choices</h2>
        <p>
          You can:
          <ul className="list-disc list-inside mt-2">
            <li>Update or delete your inventory items anytime</li>
            <li>Remove your profile photo if desired</li>
            <li>Uninstall the app to permanently delete your data</li>
          </ul>
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">5. Security</h2>
        <p>
          Your data benefits from the security features of your device (e.g.,
          Face ID, Touch ID, passcodes). We recommend keeping your device
          secured and updated.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">
          6. Changes to this Policy
        </h2>
        <p>
          We may update this Privacy Policy periodically. Changes will be posted
          within the app or on our official website (if available).
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-2">7. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us
          at:
          <br />
          📧 [learnHube@gmail.com]
        </p>
      </section>
    </div>
  );
};

export default HTrackPrivacyPolicy;
